module.exports = __webpack_public_path__ + "static/logo-11543a1747cdac251e2a9d1a2fad0457.png";